module.exports = __webpack_public_path__ + "img/Emerald.30579245.png";